import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Treatments from './pages/Treatments';
import TreatmentDetail from './pages/TreatmentDetail';
import Pricing from './pages/Pricing';
import Booking from './pages/Booking';
import PracticalInfo from './pages/PracticalInfo';
import ContactPage from './pages/Contact';

export default function App() {
  return (
    <div className="flex flex-col min-h-screen font-sans bg-white text-gray-900 selection:bg-blue-100 selection:text-blue-900">
      <ScrollToTop />
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om-mig" element={<About />} />
          <Route path="/behandlinger" element={<Treatments />} />
          <Route path="/behandlinger/:id" element={<TreatmentDetail />} />
          <Route path="/priser" element={<Pricing />} />
          <Route path="/bestil-tid" element={<Booking />} />
          <Route path="/praktisk-info" element={<PracticalInfo />} />
          <Route path="/kontakt" element={<ContactPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
